import { render, staticRenderFns } from "./Addeditproduct.vue?vue&type=template&id=67a7ba4a&scoped=true&"
import script from "./Addeditproduct.vue?vue&type=script&lang=js&"
export * from "./Addeditproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a7ba4a",
  null
  
)

export default component.exports